import {
  Button,
  CardContent,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  TextField,
  Typography
} from '@material-ui/core';
import { Search } from '@material-ui/icons';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import GetAppIcon from '@material-ui/icons/GetApp';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';
import { toast } from 'react-toastify';
import Brightness1Icon from '@material-ui/icons/Brightness1';
import html2canvas from 'html2canvas';
import { localizationTable, options } from 'constants/table';
import { useParams } from 'react-router-dom';
import { AttendanceData } from 'services/dataService';
import FileSaver from 'file-saver';
import MaterialTable, { MTableToolbar } from 'material-table';
import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState
} from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CertificateData } from 'services/dataService';
import { useStyles } from './styles';
import moment from 'moment';
import jsPDF from 'jspdf';

export default forwardRef((_, ref) => {
  const classes = useStyles();
  const tableRef = useRef();
  const [modalStatus, setModalStatus] = useState(false);
  const [modalExam, setModalExam] = useState(false);
  const [enrollment, setEnrollment] = useState(null);
  const [data, setData] = useState();
  const [evidenceModal, setEvidenceModal] = useState({
    open: false,
    loading: false,
    data: null,
  });
  const [downloadingEvidencePdf, setDownloadingEvidencePdf] = useState(false);
  const [filter, setFilter] = useState({
    name: '',
    status: 2,
  });
  const { id } = useParams();
  const { register, handleSubmit, control } = useForm();
  const { t } = useTranslation([
    'label',
    'toastify',
    'tables',
    'form',
    'button',
    'validation',
    'message',
  ]);

  const filterTable = useCallback((filter) => {
    getData(filter);
  });

  const getData = async (filter) => {
    const attendance = await AttendanceData.getAttendanceProfileDataById(id, filter);
    setData(attendance?.data?.report);
  };

  const handleDownloadCertificate = useCallback(async (rowData) => {
    try {
      toast.success(t('toastify:commons.toast_success_certificate'));
      const secondPageCanvas = await html2canvas(document.getElementById('certificate-second-page'), {
        scale: 2,
        useCORS: true,
      });
      const secondPageImage = secondPageCanvas.toDataURL('image/png');

      const requestBody = {
        id_attendance: rowData?.id_attendance,
        id_user: id,
        certificate_create_date: rowData?.finished_at,
        secondPageImage,
      };

      const { data: base64CertificateFile } = await CertificateData.downloadOffline(
        rowData?.company_course,
        requestBody
      );

      const responsePDF = await fetch(base64CertificateFile);
      const blob = await responsePDF.blob();
      FileSaver.saveAs(blob, `${rowData?.course_attendance}.pdf`);

    } catch (error) {
      console.error('Erro ao gerar o certificado:', error);
    }
  }, []);

  const handleOpenEvidence = async (rowData) => {
    setEvidenceModal({ open: true, loading: true, data: null });
    try {
      const response = await AttendanceData.getLearningEvidenceForAdmin(
        rowData.id_attendance,
        id
      );
      setEvidenceModal({ open: true, loading: false, data: response.data });
    } catch (error) {
      setEvidenceModal({ open: false, loading: false, data: null });
      toast.error(t('toastify:commons.toast_error_api'));
    }
  };

  const handleCloseEvidence = () => {
    setEvidenceModal({ open: false, loading: false, data: null });
  };

  const handleDownloadEvidencePdf = async () => {
    const documentElement = document.getElementById('learning-evidence-document');
    if (!documentElement || !evidenceModal.data) return;

    setDownloadingEvidencePdf(true);
    try {
      const canvas = await html2canvas(documentElement, {
        scale: 2,
        useCORS: true,
        backgroundColor: '#ffffff',
      });
      const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
      const margin = 10;
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const printableWidth = pageWidth - margin * 2;
      const printableHeight = pageHeight - margin * 2;
      const pageHeightInPixels = Math.floor(
        (printableHeight * canvas.width) / printableWidth
      );
      const documentRect = documentElement.getBoundingClientRect();
      const canvasScale = canvas.height / documentRect.height;
      const protectedBlocks = Array.from(
        documentElement.querySelectorAll('[data-pdf-block="true"]')
      ).map(element => {
        const rect = element.getBoundingClientRect();
        return {
          top: Math.max(0, (rect.top - documentRect.top) * canvasScale),
          bottom: Math.min(
            canvas.height,
            (rect.bottom - documentRect.top) * canvasScale
          ),
        };
      });

      let sliceStart = 0;
      let page = 0;
      while (sliceStart < canvas.height) {
        const naturalSliceEnd = Math.min(
          sliceStart + pageHeightInPixels,
          canvas.height
        );
        let sliceEnd = naturalSliceEnd;

        if (naturalSliceEnd < canvas.height) {
          const crossingBlock = protectedBlocks.find(
            block =>
              block.top > sliceStart &&
              block.top < naturalSliceEnd &&
              block.bottom > naturalSliceEnd &&
              block.top - sliceStart >= pageHeightInPixels * 0.2
          );

          if (crossingBlock) sliceEnd = Math.floor(crossingBlock.top);
        }

        if (sliceEnd <= sliceStart) sliceEnd = naturalSliceEnd;

        const sliceHeight = Math.ceil(sliceEnd - sliceStart);
        const pageCanvas = document.createElement('canvas');
        pageCanvas.width = canvas.width;
        pageCanvas.height = sliceHeight;
        const pageContext = pageCanvas.getContext('2d');
        pageContext.fillStyle = '#ffffff';
        pageContext.fillRect(0, 0, pageCanvas.width, pageCanvas.height);
        pageContext.drawImage(
          canvas,
          0,
          Math.floor(sliceStart),
          canvas.width,
          sliceHeight,
          0,
          0,
          canvas.width,
          sliceHeight
        );

        if (page > 0) pdf.addPage();
        const renderedSliceHeight =
          (sliceHeight * printableWidth) / canvas.width;
        pdf.addImage(
          pageCanvas.toDataURL('image/png'),
          'PNG',
          margin,
          margin,
          printableWidth,
          renderedSliceHeight
        );

        sliceStart = sliceEnd;
        page += 1;
      }

      const safeTrainingName = evidenceModal.data.training.name
        .replace(/[^a-zA-Z0-9À-ÿ_-]+/g, '_')
        .replace(/^_+|_+$/g, '');
      pdf.save(`evidencia_aprendizado_${safeTrainingName || 'treinamento'}.pdf`);
    } catch (error) {
      toast.error(t('toastify:commons.toast_error_api'));
    } finally {
      setDownloadingEvidencePdf(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useImperativeHandle(ref, () => ({
    updateTable() {
      getData();
    },
  }));

  const getStatus = useCallback(
    (value) => {
      if (value)
        return (
          <div className={classes.status}>
            <Brightness1Icon
              fontSize="small"
              color="primary"
              style={{ marginRight: 5 }}
            />
            {t('label:commons.label_status_active')}
          </div>
        );
      else
        return (
          <div className={classes.status}>
            <Brightness1Icon
              color="secondary"
              fontSize="small"
              style={{ marginRight: 5 }}
            />
            {t('label:commons.label_status_inactive')}
          </div>
        );
    },
    [t]
  );

  return (
    <div>
      <div
        id="certificate-second-page"
        style={{
          position: 'absolute',
          top: '-9999px',
          left: '-9999px',
          display: 'none',
          width: '1366px',
          height: '768px',
          padding: '25px',
          boxSizing: 'border-box',
          background: '#fff',
          fontFamily: 'Arial, sans-serif',
          fontSize: '16px',
          color: '#000',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <div>
          <h2 style={{ display: 'none', textAlign: 'center', fontWeight: 'bold', marginBottom: '20px', marginLeft: '20px' }}>
            Conteúdo Programático
          </h2>

          <div style={{ display: 'flex', gap: '40px' }}>
            {/* {columns.map((col, idx) => (
              <div key={idx} style={{ flex: 1 }}>
                {col.map((module, i) => (
                  <div key={i} style={{ marginBottom: '20px', breakInside: 'avoid' }}>
                    <strong style={{ display: 'block', marginBottom: '4px' }}>
                      {module.title}
                    </strong>
                    {module.lessons.map((lesson, j) => (
                      <div key={j} style={{ fontSize: '14px', lineHeight: '1.6', marginLeft: '10px' }}>
                        Aula {lesson.order?.toString().padStart(2, '0')} – {lesson.title}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            ))} */}
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
        </div>
      </div>
      <MaterialTable
        title={`${t('tables:course.title')}`}
        tableRef={tableRef}
        columns={[
          {
            title: `${'Curso'}`, field: 'course'
          },
          {
            title: `${'Treinamento'}`, field: 'course_attendance'
          },
          {
            title: `${'Início'}`, field: 'start_at'
          },
          {
            title: `${'Final'}`, field: 'finished_at',
          },
          {
            title: `${'Instrutor'}`, field: 'instructor'
          },
          {
            title: `${'Carga Horária'}`, field: 'workload'
          },
          {
            title: t('form:AttendanceEvidence.column'),
            field: 'id_learning_evidence',
            sorting: false,
            render: (rowData) => {
              if (!rowData.requires_learning_evidence) {
                return (
                  <Chip
                    className={classes.evidenceNotRequiredChip}
                    size="small"
                    label={t('form:AttendanceEvidence.notRequired')}
                  />
                );
              }

              if (!rowData.id_learning_evidence) {
                return (
                  <Chip
                    className={classes.evidencePendingChip}
                    size="small"
                    label={t('form:AttendanceEvidence.pending')}
                  />
                );
              }

              return (
                <Chip
                  clickable
                  className={classes.evidenceAnsweredChip}
                  label={t('form:AttendanceEvidence.viewEvidence')}
                  onClick={(event) => {
                    event.stopPropagation();
                    handleOpenEvidence(rowData);
                  }}
                />
              );
            },
          },
        ]}
        data={data}
        actions={[
          (rowTable) => {
            return {
              icon: 'download',
              tooltip: `${t('button:Course.btn_download_certificate')}`,
              onClick: (_, rowData) => handleDownloadCertificate(rowData),
              iconProps: {
                color: 'primary',
              },
            };
          },
        ]}
        components={{
          search: false,
          title: true,
          Toolbar: (props) => (
            <div>
              <MTableToolbar {...props} />
              <CardContent>
                <form onSubmit={handleSubmit(filterTable)}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        defaultValue={''}
                        variant="outlined"
                        name="name"
                        inputRef={register({ required: false })}
                        label={'Treinamento'}
                      />
                    </Grid>
                    <Grid item xs={12} md={1} />
                    <Grid item xs={12} md={5} className={classes.actions}>
                      <Button
                        color="primary"
                        variant="contained"
                        size="large"
                        type="submit"
                      >
                        <Search style={{ marginRight: '5px' }} />
                        {t('button:commons.btn_advanced_filter')}
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </CardContent>
            </div>
          ),
        }}
        localization={localizationTable(t)}
        options={options}
      />

      <Dialog
        fullWidth
        maxWidth="md"
        open={evidenceModal.open}
        onClose={handleCloseEvidence}
      >
        <DialogTitle className={classes.modalTitle}>
          {t('form:AttendanceEvidence.responseTitle')}
        </DialogTitle>
        <DialogContent dividers className={classes.modalContent}>
          {evidenceModal.loading && (
            <div className={classes.evidenceLoading}>
              <CircularProgress />
            </div>
          )}

          {!evidenceModal.loading && evidenceModal.data && (
            <div
              id="learning-evidence-document"
              className={classes.documentPaper}
            >
              <div className={classes.documentHeader}>
                <div>
                  <Typography className={classes.documentEyebrow}>
                    {t('form:AttendanceEvidence.documentLabel')}
                  </Typography>
                  <Typography variant="h4" className={classes.documentTitle}>
                    {t('form:AttendanceEvidence.title')}
                  </Typography>
                </div>
                <DescriptionOutlinedIcon className={classes.documentIcon} />
              </div>

              <div className={classes.documentAccent} />
              <Typography className={classes.documentTrainingTitle}>
                {evidenceModal.data.training.name}
              </Typography>

              <div className={classes.documentDetails} data-pdf-block="true">
                <Grid container>
                  <DocumentInfo
                    label={t('form:AttendanceEvidence.employee')}
                    value={evidenceModal.data.student.name}
                    classes={classes}
                  />
                  {(evidenceModal.data.student.custom_fields || []).map(
                    (field, index) => (
                      <DocumentInfo
                        key={`${field.fieldName}-${index}`}
                        label={field.fieldName}
                        value={field.fieldValue}
                        classes={classes}
                      />
                    )
                  )}
                  <DocumentInfo
                    fullWidth
                    label={t('form:AttendanceEvidence.description')}
                    value={evidenceModal.data.training.description}
                    classes={classes}
                  />
                  <DocumentInfo
                    label={t('form:AttendanceEvidence.period')}
                    value={formatEvidencePeriod(
                      evidenceModal.data.training.start_at,
                      evidenceModal.data.training.finished_at
                    )}
                    classes={classes}
                  />
                  <DocumentInfo
                    label={t('form:AttendanceEvidence.workload')}
                    value={formatEvidenceWorkload(
                      evidenceModal.data.training.workload
                    )}
                    classes={classes}
                  />
                  <DocumentInfo
                    label={t('form:AttendanceEvidence.instructor')}
                    value={evidenceModal.data.training.instructor}
                    classes={classes}
                  />
                  <DocumentInfo
                    label={t('form:AttendanceEvidence.answeredAt')}
                    value={moment(
                      evidenceModal.data.evidence.answered_at
                    ).format('DD/MM/YYYY HH:mm')}
                    classes={classes}
                  />
                </Grid>
              </div>

              <div className={classes.objectiveBox} data-pdf-block="true">
                <div className={classes.objectiveIcon}>
                  <TrackChangesIcon />
                </div>
                <div className={classes.objectiveContent}>
                  <Typography className={classes.objectiveTitle}>
                    {t('form:AttendanceEvidence.objectiveTitle')}
                  </Typography>
                  <Typography variant="body2" className={classes.objectiveText}>
                    {t('form:AttendanceEvidence.objective')}
                  </Typography>
                </div>
              </div>

              <Divider className={classes.documentDivider} />

              <EvidenceAnswer
                number="01"
                title={t('form:AttendanceEvidence.contentsCovered')}
                value={evidenceModal.data.evidence.contents_covered}
                classes={classes}
              />
              <EvidenceAnswer
                number="02"
                title={t('form:AttendanceEvidence.mainLearnings')}
                value={evidenceModal.data.evidence.main_learnings}
                classes={classes}
              />
              <EvidenceAnswer
                number="03"
                title={t('form:AttendanceEvidence.practicalApplication')}
                value={evidenceModal.data.evidence.practical_application}
                classes={classes}
              />

              <div className={classes.declarationBox} data-pdf-block="true">
                <CheckCircleOutlineIcon className={classes.declarationIcon} />
                <div>
                  <Typography variant="subtitle2" className={classes.declarationTitle}>
                    {t('form:AttendanceEvidence.accepted')}
                  </Typography>
                  <Typography variant="body2" className={classes.declarationText}>
                    {t('form:AttendanceEvidence.declaration')}
                  </Typography>
                </div>
              </div>

              <Typography
                className={classes.documentFooter}
                data-pdf-block="true"
              >
                {t('form:AttendanceEvidence.electronicRecord', {
                  name: evidenceModal.data.student.name,
                  date: moment(
                    evidenceModal.data.evidence.answered_at
                  ).format('DD/MM/YYYY HH:mm'),
                })}
              </Typography>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            variant="contained"
            startIcon={downloadingEvidencePdf ? null : <GetAppIcon />}
            disabled={evidenceModal.loading || downloadingEvidencePdf}
            onClick={handleDownloadEvidencePdf}
          >
            {downloadingEvidencePdf && (
              <CircularProgress size={18} className={classes.pdfProgress} />
            )}
            {t('form:AttendanceEvidence.downloadPdf')}
          </Button>
          <Button color="primary" onClick={handleCloseEvidence}>
            {t('form:AttendanceEvidence.close')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
});

function DocumentInfo({ label, value, classes, fullWidth }) {
  const displayValue = formatDocumentValue(value);

  return (
    <Grid item xs={12} sm={fullWidth ? 12 : 6}>
      <div className={classes.documentInfo}>
        <Typography className={classes.documentInfoLabel}>{label}</Typography>
        <Typography className={classes.documentInfoValue}>
          {displayValue}
        </Typography>
      </div>
    </Grid>
  );
}

function formatDocumentValue(value) {
  if (value == null || value === '') return '-';
  if (Array.isArray(value)) return value.join(', ') || '-';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
}

function formatEvidenceWorkload(minutes) {
  if (minutes == null || Number.isNaN(Number(minutes))) return '-';
  const totalMinutes = Number(minutes);
  const hours = Math.floor(totalMinutes / 60);
  const remainingMinutes = totalMinutes % 60;
  return `${String(hours).padStart(2, '0')}:${String(remainingMinutes).padStart(
    2,
    '0'
  )}`;
}

function formatEvidencePeriod(startAt, finishedAt) {
  const start = startAt ? moment(startAt).format('DD/MM/YYYY HH:mm') : '-';
  const end = finishedAt ? moment(finishedAt).format('DD/MM/YYYY HH:mm') : '-';
  return `${start} - ${end}`;
}

function EvidenceAnswer({ number, title, value, classes }) {
  return (
    <div className={classes.answerSection} data-pdf-block="true">
      <div className={classes.answerNumber}>{number}</div>
      <div className={classes.answerContent}>
        <Typography variant="subtitle1" className={classes.answerTitle}>
          {title}
        </Typography>
        <Typography variant="body2" className={classes.answerText}>
          {value}
        </Typography>
      </div>
    </div>
  );
}
